import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useColorMode } from '../../theme/ThemeProvider';
import { cn } from '../../lib/utils';

const ColorModeToggle = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { mode, cycleMode } = useColorMode();
  const label = t('color_mode.toggle', {
    mode: t(`color_mode.${mode}`),
    defaultValue: `Color mode: ${mode}. Click to change.`,
  });
  const Icon = mode === 'dark' ? Moon : Sun;

  return (
    <button
      type="button"
      onClick={cycleMode}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-lg text-darker-gold hover:bg-darker-gold-50 transition-colors',
        className
      )}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
};

export default ColorModeToggle;
